import Button from "./Button";

export default function EmptyState({

    title,

    subtitle,

    actionText,

    onAction

}){

    return(

        <div className="crm-empty-state">

            <h2>

                {title}

            </h2>

            <p>

                {subtitle}

            </p>

            {

                actionText &&

                <Button

                    onClick={onAction}

                >

                    {actionText}

                </Button>

            }

        </div>

    );

}